var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3501_10246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.091 26.6107C52.2113 25.4295 50.8568 24.75 49.374 24.75H47.2523V16.875C47.2523 11.2928 42.7095 6.75 37.1273 6.75H23.5013C22.9793 6.75 22.4573 6.62625 21.9915 6.3945L14.8928 2.844C14.1165 2.457 13.248 2.25 12.3773 2.25H7.87725C3.5325 2.25 0 5.7825 0 10.125V41.625C0 47.2072 4.54275 51.75 10.125 51.75H40.6305C45.1373 51.75 49.0343 48.8498 50.3438 44.4847L53.802 30.6743C54.225 29.2658 53.964 27.7852 53.091 26.6107ZM2.25 41.625V10.125C2.25 7.0245 4.77225 4.5 7.875 4.5H12.375C12.897 4.5 13.419 4.62375 13.8848 4.8555L20.9835 8.406C21.7598 8.793 22.6283 9 23.499 9H37.125C41.4675 9 45 12.5325 45 16.875V24.75H18.2588C14.9063 24.75 11.9183 26.8605 10.809 30.0465L5.33475 47.8755C3.45825 46.4355 2.24775 44.1698 2.24775 41.6273L2.25 41.625ZM51.633 30.078L48.1748 43.8885C47.1668 47.2455 44.1338 49.5 40.6283 49.5H10.125C9.14625 49.5 8.21025 49.32 7.3485 48.9937L12.9488 30.744C13.7295 28.503 15.8625 26.9977 18.2588 26.9977H49.3718C50.1368 26.9977 50.832 27.3443 51.2865 27.9518C51.732 28.5503 51.8648 29.3085 51.633 30.0757V30.078Z",
    fill: "#0073FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3501_10246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project-icon.52da777f373cc2d41f60a9330a3804cf.svg";
export { ForwardRef as ReactComponent };